module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "banner_2.0310f5ac.webp" + "?" + Date.now();